





















































































































import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref
} from '@nuxtjs/composition-api'
import BlackFridayImageBox from '~/components/car/banners/black-friday/BlackFridayImageBox.vue'
import { useStatic } from '~/compositions/useStatic'
import { ONE_SECOND_MS } from '~/constants/duration'
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  subDays,
  subHours,
  subMinutes
} from 'date-fns'
import { getRandomNumberBetween } from '~/utils/number'
import { useNamespacedStore } from '~/compositions/store'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  components: { BlackFridayImageBox },
  setup() {
    const s = useStatic()

    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const isMobile = computed(() => userAgentGetters('isMobile'))

    const dice = getRandomNumberBetween(1, 100)
    const dice2 = getRandomNumberBetween(1, 100)
    const dice3 = getRandomNumberBetween(1, 100)

    const vehicleImage = computed(() => {
      if (dice < 70) {
        return {
          src: s('/nuxt-static/img/black-friday/oximata.png'),
          class: undefined
        }
      } else {
        return {
          src: s('/nuxt-static/img/black-friday/oximata2.png'),
          class: 'tw-max-h-[80px] tw-max-w-[83%]'
        }
      }
    })
    const partsImage = computed(() => {
      if (dice2 < 50) {
        return {
          src: s('/nuxt-static/img/black-friday/antallaktika.png'),
          class: undefined
        }
      } else {
        return {
          src: s('/nuxt-static/img/black-friday/antallaktika2.png'),
          class: 'tw-max-h-[77px] !tw-top-[11%] tw-max-w-[88%]'
        }
      }
    })
    const xymaImage = computed(() => {
      if (dice3 < 50) {
        return {
          src: s('/nuxt-static/img/black-friday/xyma.png'),
          class: undefined
        }
      } else {
        return {
          src: s('/nuxt-static/img/black-friday/xyma2.png'),
          class: 'tw-max-h-[80px]'
        }
      }
    })

    const difference = ref([])
    const countdownInterval = ref(null)
    const countdownEnded = ref(false)
    const { tc } = useI18n()

    const targetDate = computed(() => {
      return new Date(2022, 10, 23)
    })

    onBeforeUnmount(() => {
      clearInterval(countdownInterval.value)
    })

    onMounted(() => {
      if (!countdownEnded.value) {
        countdownInterval.value = setInterval(() => {
          createDifference()
        }, ONE_SECOND_MS)
      }
    })

    const createDifference = () => {
      let targetTime = targetDate.value
      const currentTime = new Date()

      const daysDiff = differenceInDays(targetTime, currentTime)
      targetTime = subDays(targetTime, daysDiff)
      const hoursDiff = differenceInHours(targetTime, currentTime)
      targetTime = subHours(targetTime, hoursDiff)
      const minutesDiff = differenceInMinutes(targetTime, currentTime)
      targetTime = subMinutes(targetTime, minutesDiff)
      const secondsDiff = differenceInSeconds(targetTime, currentTime)

      if (
        daysDiff <= 0 &&
        hoursDiff <= 0 &&
        minutesDiff <= 0 &&
        secondsDiff <= 0
      ) {
        onCountdownEnd()
        return
      }

      difference.value = [
        {
          value: daysDiff,
          label: tc('day | days', daysDiff).toLowerCase(),
          mobileLabel: daysDiff === 1 ? 'Day' : 'Days',
          visible: daysDiff > 0
        },
        {
          value: hoursDiff,
          label: tc('hour | hours', hoursDiff).toLowerCase(),
          mobileLabel: hoursDiff === 1 ? 'Hour' : 'Hours',
          visible: daysDiff > 0 || hoursDiff > 0
        },
        {
          value: minutesDiff,
          label: tc('minute | minutes', minutesDiff).toLowerCase(),
          mobileLabel: 'Min',
          visible: daysDiff > 0 || hoursDiff > 0 || minutesDiff > 0
        },
        {
          value: secondsDiff,
          label: tc('seconds | seconds', secondsDiff).toLowerCase(),
          mobileLabel: 'Sec',
          visible:
            daysDiff > 0 || hoursDiff > 0 || minutesDiff > 0 || secondsDiff > 0
        }
      ]
    }

    const onCountdownEnd = () => {
      countdownEnded.value = true
      difference.value = []
      clearInterval(countdownInterval.value)
    }

    createDifference()

    return {
      vehicleImage,
      partsImage,
      xymaImage,
      difference,
      countdownInterval,
      countdownEnded,
      targetDate,
      onCountdownEnd,
      isMobile
    }
  }
})
